import React from 'react';
import { TutorialProvider } from '@/contexts/TutorialContext';
import { TutorialOverlay } from './TutorialOverlay';

interface TutorialProps {
  children: React.ReactNode;
}

export const Tutorial: React.FC<TutorialProps> = ({ children }) => {
  return (
    <TutorialProvider>
      {children}
      <TutorialOverlay />
    </TutorialProvider>
  );
};
